import ClearIcon from "@mui/icons-material/Clear";
import { Grid } from "@mui/material";
import { gradeOptions } from "../../functions/general";
import ReusableAutocompleteWithID from "../general/ReusableAutocompleteWithID";
import ReusableButton from "../general/ReusableButton";
import ReusableTextField from "../general/ReusableTextField";
const containerStyle = { paddingBottom: 20 };
const iconStyle = { fontSize: 36, cursor: "pointer", marginRight: 30 };
export default function Level({
  marked_manually,
  count,
  levelCount,
  competition,
  setCompetition,
  updateRounds,
  collectionOptions,
}) {
  const round = competition.rounds[count];
  const level = round.levels[levelCount];
  const { id, name, collection_id, grades } = level;
  const updateLevel = (identifier, value) => {
    let newCompetition = { ...competition };
    newCompetition.rounds[count].levels[levelCount][identifier] = value;
    setCompetition(newCompetition);
  };
  let takenCollections = round.levels
    .filter((l) => id !== l.id)
    .map((l) => l.collection_id);
  let filteredCollectionOptions = collectionOptions;

  let availableGrades = gradeOptions.filter((g) =>
    competition.allowed_grades.includes(g.id)
  );
  let takenGrades = round.levels
    .filter((l) => id !== l.id)
    .map((l) => l.grades)
    .flat();
  let filteredGradeOptions = availableGrades.filter(
    (g) => !takenGrades.includes(g.id) || grades.includes(g.id)
  );
  return (
    <Grid container alignItems="center" style={containerStyle}>
      <ClearIcon
        style={iconStyle}
        onClick={() => updateRounds("deleteLevel", levelCount)}
      />
      <ReusableTextField
        type="default"
        width={240}
        placeholder="Level*"
        state={name}
        bgColor="var(--color-surface-subtle)"
        marginRight={30}
        borderColor="var(--color-border-strong)"
        setState={updateLevel}
        target="name"
        required
        onBlur
      />
      {!marked_manually && (
        <ReusableAutocompleteWithID
          type="default"
          placeholder="Collection*"
          width={320}
          bgColor="#FFF"
          btnBgColor="var(--color-primary)"
          state={collection_id}
          setState={updateLevel}
          target="collection_id"
          required
          borderColor="var(--color-border-strong)"
          marginRight={30}
          options={filteredCollectionOptions.map((c) => ({
            id: c.id,
            option: c.name,
          }))}
        />
      )}
      {/* <ReusableButton text='Preview Collection' height={48} bgColor='var(--color-primary)' fontSize={15} marginRight={30} /> */}
      {/*temporary*/}
      {!marked_manually && competition.difficulty_group_id !== 0 && (
        <ReusableButton
          text="Assign Difficulty and Points"
          height={48}
          bgColor="var(--color-primary)"
          fontSize={15}
          marginRight={30}
          disabledButton={!id}
          // to={level.collection && `/assignDifficulty/${competition.competitionID}/${roundCount}/${levelCount}/${level.collection}`}
          // blank
          to={`/assignDifficulty?competition_id=${competition.id}&round_id=${round.id}&level_id=${id}`}
          blank
        />
      )}
      <ReusableAutocompleteWithID
        type="default"
        placeholder="Grades*"
        width={320}
        bgColor="#FFF"
        borderColor="var(--color-border-strong)"
        state={grades}
        setState={updateLevel}
        multiple
        marginRight={30}
        target="grades"
        required
        options={filteredGradeOptions.map((g) => ({
          id: g.id,
          option: g.name,
        }))}
      />
      {/* {JSON.stringify(level)} */}
    </Grid>
  );
}
